export default "__VITE_ASSET__HGk4f_UX__"